import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import { Box, Grid, IconButton, Tooltip } from '@material-ui/core';
import HomeIcon from '@material-ui/icons/Home';
import PrintIcon from '@material-ui/icons/Print';
import HelpIcon from '@material-ui/icons/Help';
import PlanningMeetingIcon from '../../../assets/img/planner-meeting-icon.svg';
import SeniorPlanning1 from '../../SeniorPlanningForm1/SeniorPlanning1';
import { useReactToPrint } from 'react-to-print';
import { isStudent, isAlumni } from '../../../util/miscUtil';

const Planning1 = ({
  senior,
  alumni,
  roles,
  handleHelp,
  store,
  auth,
  handleAfterSaveReturn,
  setPage,
  handleReturnToSeniorList,
  classes,
  handleGotoAdminHomepage,
}) => {
  const componentRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  return (
    <summary className={classes.subPageContainer} ref={componentRef}>
      <div className={classes.unprintedContent}>
        <div style={{ width: '100%', margin: 0 }} className={classes.pageBanner}>
          <div className={classes.centerForm}>
            <Box
              sx={{
                width: '100%',
                maxWidth: {
                  xs: '380px',
                  sm: '540px',
                  md: '868px',
                  lg: '1320px',
                  xl: '1320px',
                },
              }}
            >
              <Grid container spacing={0} direction='row' style={{ marginBottom: '60px' }} className={classes.unprintedContent}>
                <Grid item xs={12} align='left'>
                  <summary className={classes.header} style={{ paddingTop: '30px' }}>
                    <Grid container direction='row' className={classes.subPageHeaderWithIcons}>
                      <Grid item xs={false} sm={1} md={1} lg={1} align='center' className={classes.logoContainer}>
                        <img src={PlanningMeetingIcon} alt='Planning Form Icon' className={classes.logo} />
                      </Grid>
                      <Grid item xs={11} sm={11} md={8} lg={8} align='left'>
                        <div className={classes.headerContent}>
                          <div className={classes.headerText}>
                            <div className={classes.title}>
                              {isStudent(roles) || isAlumni(roles) ? (
                                <main>Planning Form - Meeting #1</main>
                              ) : (
                                <main>
                                  Planning Form - Meeting #1 for{' '}
                                  {senior.alumni_updated_first_name ? senior.alumni_updated_first_name : senior.first_name}{' '}
                                  {senior.alumni_updated_last_name ? senior.alumni_updated_last_name : senior.last_name}
                                </main>
                              )}
                            </div>
                          </div>
                        </div>
                        <div style={{ color: '#fff' }}>
                          {isStudent(roles) && <main>Please complete this form and bring to your Planning Meeting #1.</main>}
                        </div>
                      </Grid>
                      <Grid item xs={12} sm={12} md={3} lg={3} align='left' className={classes.unprintedContent}>
                        <div className={classes.plannerIcons}>
                          <Tooltip title='Click to return to the planner home page.' placement='bottom'>
                            <IconButton color='inherit' aria-label='return home' onClick={(e) => setPage('home')}>
                              <HomeIcon className={classes.homeIcon} style={{ color: '#fff' }} />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title='Click to return to open the printer dialog.' placement='bottom'>
                            <IconButton color='inherit' aria-label='print planning meeting 1 form' onClick={handlePrint}>
                              <PrintIcon className={classes.homeIcon} style={{ color: '#fff' }} />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title='Click to return to view printer tips & tricks.' placement='bottom'>
                            <IconButton color='inherit' aria-label='printer tips and tricks' onClick={handleHelp}>
                              <HelpIcon className={classes.homeIcon} style={{ color: '#fff' }} />
                            </IconButton>
                          </Tooltip>
                        </div>
                      </Grid>
                    </Grid>
                  </summary>
                </Grid>
              </Grid>
            </Box>
          </div>

          {!isStudent(roles) && !isAlumni(roles) && (
            <div className={classes.centerForm}>
              <Box
                sx={{
                  width: '100%',
                  maxWidth: {
                    xs: '380px',
                    sm: '540px',
                    md: '868px',
                    lg: '1280px',
                    xl: '1280px',
                  },
                }}
              >
                <Grid container direction='row' className={classes.unprintedContent}>
                  <Grid item xs={12}>
                    <div className={classes.breadcrumbs}>
                      <Breadcrumbs separator='›' aria-label='breadcrumbs' className={classes.alignCrumb}>
                        <span className={classes.breadCrumbLink} style={{ marginTop: '-2px' }} onClick={(e) => handleGotoAdminHomepage()}>
                          <HomeIcon style={{ fontSize: '1.30rem' }} />
                          <span style={{ margin: '1px 0 0 1px' }}>Home</span>
                        </span>
                        <span className={classes.breadCrumbLink} style={{ marginTop: '-1px' }} onClick={(event) => handleReturnToSeniorList()}>
                          {alumni ? 'Alumni' : 'High School Seniors'}
                        </span>
                        <span className={classes.breadCrumbLink} style={{ marginTop: '-1px' }} onClick={(e) => setPage('home')}>
                          {senior && senior.alumni_updated_first_name ? senior.alumni_updated_first_name : senior.first_name}{' '}
                          {senior && senior.alumni_updated_last_name ? senior.alumni_updated_last_name : senior.last_name}
                        </span>
                        <span className={classes.breadCrumbText} style={{ marginTop: '-1px' }}>
                          Planning Form #1
                        </span>
                      </Breadcrumbs>
                    </div>
                  </Grid>
                </Grid>
              </Box>
            </div>
          )}
        </div>
      </div>

      <div className={classes.printedContent}>
        {/* <div style={{ width: '100%', margin: 0 }} className={classes.pageBanner}> */}
        <div className={classes.centerForm}>
          <Box
            sx={{
              width: '100%',
              maxWidth: {
                xs: '380px',
                sm: '540px',
                md: '868px',
                lg: '1320px',
                xl: '1320px',
              },
            }}
          >
            <Grid container spacing={0} direction='row' style={{ marginBottom: '60px' }} className={classes.unprintedContent}>
              <Grid item xs={12} align='left'>
                <summary className={classes.header} style={{ paddingTop: '30px' }}>
                  <Grid container direction='row' className={classes.subPageHeaderWithIcons}>
                    <Grid item xs={false} sm={1} md={1} lg={1} align='center' className={classes.logoContainer}>
                      <img src={PlanningMeetingIcon} alt='Planning Form Icon' className={classes.logo} />
                    </Grid>
                    <Grid item xs={11} sm={11} md={8} lg={8} align='left'>
                      <div className={classes.headerContent}>
                        <div className={classes.headerText}>
                          <div className={classes.title}>
                            {isStudent(roles) || isAlumni(roles) ? (
                              <main>Planning Form - Meeting #1</main>
                            ) : (
                              <main>
                                Planning Form - Meeting #1 for{' '}
                                {senior.alumni_updated_first_name ? senior.alumni_updated_first_name : senior.first_name}{' '}
                                {senior.alumni_updated_last_name ? senior.alumni_updated_last_name : senior.last_name}
                              </main>
                            )}
                          </div>
                        </div>
                      </div>
                      <div style={{ color: '#fff' }}>
                        {isStudent(roles) && <main>Please complete this form and bring to your Planning Meeting #1.</main>}
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={12} md={3} lg={3} align='left' className={classes.unprintedContent}>
                      <div className={classes.plannerIcons}>
                        <Tooltip title='Click to return to the planner home page.' placement='bottom'>
                          <IconButton color='inherit' aria-label='return home' onClick={(e) => setPage('home')}>
                            <HomeIcon className={classes.homeIcon} style={{ color: '#fff' }} />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title='Click to return to open the printer dialog.' placement='bottom'>
                          <IconButton color='inherit' aria-label='print planning meeting 1 form' onClick={handlePrint}>
                            <PrintIcon className={classes.homeIcon} style={{ color: '#fff' }} />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title='Click to return to view printer tips & tricks.' placement='bottom'>
                          <IconButton color='inherit' aria-label='printer tips and tricks' onClick={handleHelp}>
                            <HelpIcon className={classes.homeIcon} style={{ color: '#fff' }} />
                          </IconButton>
                        </Tooltip>
                      </div>
                    </Grid>
                  </Grid>
                </summary>
              </Grid>
            </Grid>
          </Box>
        </div>

        {!isStudent(roles) && !isAlumni(roles) && (
          <div className={classes.centerForm}>
            <Box
              sx={{
                width: '100%',
                maxWidth: {
                  xs: '380px',
                  sm: '540px',
                  md: '868px',
                  lg: '1280px',
                  xl: '1280px',
                },
              }}
            >
              <Grid container direction='row' className={classes.unprintedContent}>
                <Grid item xs={12}>
                  <div className={classes.breadcrumbs}>
                    <Breadcrumbs separator='›' aria-label='breadcrumbs' className={classes.alignCrumb}>
                      <span className={classes.breadCrumbLink} style={{ marginTop: '-2px' }} onClick={(e) => handleGotoAdminHomepage()}>
                        <HomeIcon style={{ fontSize: '1.30rem' }} />
                        <span style={{ margin: '1px 0 0 1px' }}>Home</span>
                      </span>
                      <span className={classes.breadCrumbLink} style={{ marginTop: '-1px' }} onClick={(event) => handleReturnToSeniorList()}>
                        {alumni ? 'Alumni' : 'High School Seniors'}
                      </span>
                      <span className={classes.breadCrumbLink} style={{ marginTop: '-1px' }} onClick={(e) => setPage('home')}>
                        {senior && senior.alumni_updated_first_name ? senior.alumni_updated_first_name : senior.first_name}{' '}
                        {senior && senior.alumni_updated_last_name ? senior.alumni_updated_last_name : senior.last_name}
                      </span>
                      <span className={classes.breadCrumbText} style={{ marginTop: '-1px' }}>
                        Planning Form #1
                      </span>
                    </Breadcrumbs>
                  </div>
                </Grid>
              </Grid>
            </Box>
          </div>
        )}
        {/* </div> */}
      </div>

      <div className={classes.centerForm}>
        <Box
          sx={{
            width: '100%',
            maxWidth: {
              xs: '380px',
              sm: '540px',
              md: '868px',
              lg: '1320px',
              xl: '1320px',
            },
          }}
        >
          <Grid container spacing={3} direction='row' style={{ marginTop: '35px' }}>
            <Grid item xs={12} align='left' className={classes.printedContent}>
              <section className={classes.pageTitle}>
                <span className={classes.printHeaderText}>Planning Form - Meeting #1</span>
              </section>
              <aside className={classes.printHeaderDesc}>Please complete this form and bring to your Planning Form - Meeting #1.</aside>
            </Grid>
            <Grid item xs={12}>
              <div style={{ width: '95%', margin: '0 auto 0 auto' }}>
                <SeniorPlanning1 SeniorStore={store} AuthStore={auth} handleSaveReturn={handleAfterSaveReturn} />
              </div>
            </Grid>
          </Grid>
        </Box>
      </div>
    </summary>
  );
};

Planning1.propTypes = {
  senior: PropTypes.object,
  alumni: PropTypes.bool,
  roles: PropTypes.array,
  handleHelp: PropTypes.func,
  store: PropTypes.object,
  auth: PropTypes.object,
  handleAfterSaveReturn: PropTypes.func,
  setPage: PropTypes.func,
  handleReturnToSeniorList: PropTypes.func,
  classes: PropTypes.object.isRequired,
  handleGotoAdminHomepage: PropTypes.func.isRequired,
};

export default Planning1;
